import { FavouriteLockerType } from "./LockerDataTypes"

export interface TrackedAction {
    type: ActionType,
    countryId?: number,
    countyId?: number,
    cityId?: number,
    lockerId?: number,
    domain: string,
    integratorId: string,
    correlationId: string,
    favouriteLockerType?: FavouriteLockerType,
    userFingerprint?: string
    apiUsername?: string
}

export enum ActionType {
    ApplicationLoad = 0,
    LockerSelected = 1,
    LockerFavourite = 2,
    ApplicationClosed = 3
}

export interface TrackedFavouriteLocker {
    lockerId: number,
    isFavouriteLocker: boolean,
    favouriteLockerType: FavouriteLockerType
}
